import { Link } from 'react-router-dom';
import {
  BookOpen,
  Users,
  Calendar,
  FileText,
  Settings,
  CreditCard,
  MessageSquare,
  BarChart,
  Shield,
  HelpCircle,
  type LucideIcon,
} from 'lucide-react';
import type { HelpCategory } from '@/hooks/useHelp';

const iconMap: Record<string, LucideIcon> = {
  'book-open': BookOpen,
  users: Users,
  calendar: Calendar,
  'file-text': FileText,
  settings: Settings,
  'credit-card': CreditCard,
  'message-square': MessageSquare,
  'bar-chart': BarChart,
  shield: Shield,
  'help-circle': HelpCircle,
};

interface HelpCategoryCardProps {
  category: HelpCategory;
  articleCount?: number;
}

export function HelpCategoryCard({ category, articleCount }: HelpCategoryCardProps) {
  const IconComponent = iconMap[category.icon] ?? HelpCircle;

  return (
    <Link
      to={`/help/${category.slug}`}
      className="group block rounded-xl border border-gray-200 bg-white p-6 shadow-sm transition-all hover:shadow-md dark:border-gray-700 dark:bg-card-dark"
    >
      <div className="flex items-start gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600 transition-colors group-hover:bg-indigo-600 group-hover:text-white dark:bg-indigo-900/30 dark:text-indigo-400 dark:group-hover:bg-indigo-600 dark:group-hover:text-white">
          <IconComponent className="h-6 w-6" />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="text-lg font-semibold text-gray-900 group-hover:text-indigo-600 dark:text-white dark:group-hover:text-indigo-400">
            {category.title}
          </h3>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{category.description}</p>
          {articleCount !== undefined && (
            <p className="mt-2 text-xs text-gray-500 dark:text-gray-500">
              {articleCount} {articleCount === 1 ? 'artikel' : 'artikler'}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
